(function () {
  'use strict';

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_REVISION = '2024-10-15';
  var MIN_SUBMIT_DELAY_MS = 3000;

  function normalizePhone(raw) {
    if (!raw) return null;
    var cleaned = String(raw).replace(/[\s\-().]/g, '');
    if (!cleaned) return null;
    if (cleaned.indexOf('+') === 0) return cleaned;
    if (cleaned.indexOf('00') === 0) return '+' + cleaned.slice(2);
    if (cleaned.indexOf('0') === 0) return '+31' + cleaned.slice(1);
    return '+31' + cleaned;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showError(errorEl, message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.setAttribute('data-visible', 'true');
  }

  function clearError(errorEl) {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.removeAttribute('data-visible');
  }

  function setLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      btn.setAttribute('disabled', 'disabled');
      btn.textContent = 'Verwerken…';
    } else {
      btn.removeAttribute('disabled');
      var defaultLabel = btn.getAttribute('data-default-label') || 'Inschrijven';
      btn.textContent = defaultLabel;
    }
  }

  function buildPayload(form, listId) {
    var data = new FormData(form);
    var email = (data.get('email') || '').toString().trim();
    var firstName = (data.get('first_name') || '').toString().trim();
    var lastName = (data.get('last_name') || '').toString().trim();
    var phone = normalizePhone((data.get('phone_number') || '').toString().trim());
    var birthday = (data.get('birthday') || '').toString().trim();
    var gender = (data.get('gender') || '').toString().trim();

    var profileAttrs = {
      email: email,
      first_name: firstName,
      last_name: lastName,
      properties: {
        birthday: birthday,
        gender: gender
      }
    };

    if (phone) {
      profileAttrs.phone_number = phone;
    }

    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Newsletter Landing Page',
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttrs
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: listId }
          }
        }
      }
    };
  }

  function showSuccess(form) {
    var sectionRoot = form.closest('.nl-landing__content') || form.parentElement;
    if (!sectionRoot) return;
    var successEl = sectionRoot.querySelector('[data-success]');
    if (successEl) {
      successEl.removeAttribute('hidden');
    }
    form.setAttribute('hidden', 'hidden');
    if (successEl && typeof successEl.scrollIntoView === 'function') {
      successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function validate(form, errorEl) {
    var email = (form.querySelector('input[name="email"]') || {}).value || '';
    var first = (form.querySelector('input[name="first_name"]') || {}).value || '';
    var last = (form.querySelector('input[name="last_name"]') || {}).value || '';
    var birthday = (form.querySelector('input[name="birthday"]') || {}).value || '';
    var gender = form.querySelector('input[name="gender"]:checked');

    if (!email.trim() || !isValidEmail(email.trim())) {
      showError(errorEl, 'Vul een geldig e-mailadres in.');
      return false;
    }
    if (!first.trim()) {
      showError(errorEl, 'Vul je voornaam in.');
      return false;
    }
    if (!last.trim()) {
      showError(errorEl, 'Vul je achternaam in.');
      return false;
    }
    if (!birthday) {
      showError(errorEl, 'Vul je geboortedatum in.');
      return false;
    }
    if (!gender) {
      showError(errorEl, 'Selecteer je geslacht.');
      return false;
    }
    return true;
  }

  function bindForm(form) {
    var companyId = form.getAttribute('data-klaviyo-company-id');
    var listId = form.getAttribute('data-klaviyo-list-id');
    if (!companyId || !listId) {
      console.warn('[newsletter-landing] Klaviyo config missing on form', form);
      return;
    }
    var submitBtn = form.querySelector('[data-submit-btn]');
    var errorEl = form.querySelector('[data-error]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      // Honeypot: silently reject if filled (bot signal)
      var honeypot = form.querySelector('input[name="url"]');
      if (honeypot && honeypot.value.trim() !== '') {
        return;
      }

      // Timing check: reject submits that happen too fast (bot signal)
      var initTime = parseInt(form.getAttribute('data-init-time'), 10);
      if (initTime && Date.now() - initTime < MIN_SUBMIT_DELAY_MS) {
        return;
      }

      clearError(errorEl);

      if (!validate(form, errorEl)) {
        return;
      }

      setLoading(submitBtn, true);

      var payload = buildPayload(form, listId);
      var url = KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId);

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (response.status === 202) {
            showSuccess(form);
            return null;
          }
          return response.text().then(function (body) {
            var detail = '';
            try {
              var parsed = JSON.parse(body);
              if (parsed && parsed.errors && parsed.errors[0]) {
                detail = parsed.errors[0].detail || parsed.errors[0].title || '';
              }
            } catch (e) {
              // ignore JSON parse errors — body might be empty
            }
            throw new Error(detail || ('Klaviyo error (HTTP ' + response.status + ')'));
          });
        })
        .catch(function (err) {
          console.error('[newsletter-landing] submit failed', err);
          var msg = (err && err.message) ? err.message : 'Onbekende fout';
          showError(errorEl, 'Inschrijving mislukt: ' + msg);
          setLoading(submitBtn, false);
        });
    });
  }

  function resetState(form) {
    form.removeAttribute('hidden');
    form.setAttribute('data-init-time', String(Date.now()));
    var sectionRoot = form.closest('.nl-landing__content') || form.parentElement;
    if (sectionRoot) {
      var successEl = sectionRoot.querySelector('[data-success]');
      if (successEl) successEl.setAttribute('hidden', 'hidden');
    }
    var errorEl = form.querySelector('[data-error]');
    clearError(errorEl);
    var submitBtn = form.querySelector('[data-submit-btn]');
    setLoading(submitBtn, false);
    var honeypot = form.querySelector('input[name="url"]');
    if (honeypot) honeypot.value = '';
  }

  function init() {
    var forms = document.querySelectorAll('form[data-klaviyo-form]');
    for (var i = 0; i < forms.length; i++) {
      resetState(forms[i]);
      if (forms[i].getAttribute('data-bound') === 'true') continue;
      forms[i].setAttribute('data-bound', 'true');
      bindForm(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the theme editor re-renders the section
  document.addEventListener('shopify:section:load', init);

  // Re-init when browser restores page from back-forward cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) init();
  });
})();
